import { createContext } from 'react';
import { GrowIntelContextType } from '../types/growintel-context';

const initialState: GrowIntelContextType = {
  service: null,
  lib: {
    identityService: null,
    aishaService: null,
  },
  user: null,
  config: {
    initializeGrowintel: () => {},
    refreshUser: async () => {},
  },
  brands: [],
  metadata: {
    areas: [],
    cities: [],
    cuisines: [],
    areasWithCity: [],
  },
  isMetaDataLoading: true,
};

export const GrowIntelContext = createContext<GrowIntelContextType | null>(
  initialState,
);
